import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractStatusAuditLog.List.IRequest;
type Response = Api.Core.ContractStatusAuditLog.List.IResponse;
type Headers = Api.Core.ContractStatusAuditLog.List.IHeaders;
const url = '/api/Sales/ContractStatusAuditLog';
export default async function contractStatusAuditLogListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
